export enum Experiment {
  EnableEarnPointsLimits = 'enableEarnPointsLimits',
  EnablePointsAdjustment = 'enablePointsAdjustment',
  CheckoutPluginUseCartV2 = 'checkoutPluginUseCartV2',
  CheckoutPluginSlotBrand = 'checkoutPluginSlotBrand',
  LoyaltyThumbnails = 'loyaltyThumbnails',
}
